<template>
    <el-row class="mb-1">

        <!--模板下载-->
        <el-popover placement="top" width="160" v-model="visible">
            <p>您确定要下载模板吗？</p>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="downloadTem('tmalljieyudetail.xlsx')">确定</el-button>
            </div>
            <el-button type="primary" slot="reference">模板下载</el-button>
        </el-popover>

        <!--文件上传-->
        <div id="app">
            <input type="file" @change="getFile($event)">
            <input type="button" value="上传" @click="upload()">
        </div>

    </el-row>
</template>

<script>

import frmarketApi from "../../../../api/frmarket/index";
import axios from "axios";


export default {

    data() {
        return {
            visible: false,
            formData: new FormData(),
        }
    },

    methods: {
        // 文件下载
        downloadTem(par) {
            frmarketApi.downloadTem(par).then((res) => {
                const blob = new Blob([res])
                const downloadElement = document.createElement('a')
                downloadElement.download = par
                const href = window.URL.createObjectURL(blob)
                downloadElement.href = href
                document.body.appendChild(downloadElement)
                downloadElement.click()
                document.body.removeChild(downloadElement)
                window.URL.revokeObjectURL(href)
            });
        },

        upload() {
            frmarketApi.uploadZhihuinfotab(this.formData).then((res) => {
                if (res.status == 200) {
                    alert("success");
                }
            });
        },
        getFile(event) {
            let file = event.target.files[0];
            let fileName = file.name;
            let index = fileName.lastIndexOf(".");
            if (index != -1) {
                let suffix = fileName.substr(index + 1).toLowerCase();
                this.formData.append("file",file);
            }
        }
    }
};
</script>